export const CarouselTexts = {
  viewAll: 'همه'
};

export const verticalDoctorCardTexts = {
  viewProfile: 'شروع مشاوره',
  viewOnlineProfile: 'شروع مشاوره',
  viewOfflineProfile: 'رزرو مشاوره',
  viewAll: 'همه'
};
